export const ANONYMOUSLY_BOOKINGS_REVIEWS = 'anonymouslyBookingsReviews'
export const EMPLOYEES_REVIEWS_AS_CLIENT = 'employeesReviewsAsClient'
export const REVIEWS_QUERY_KEY = 'reviews'
export const ARCHIVED_REVIEWS_QUERY_KEY = 'archivedReviews'
